import React from 'react'
import PropTypes from 'prop-types'
import { Disclosure } from 'components'
import { AgreementDetailsPanelContent } from '../components'

const propTypes = {
  sectionName: PropTypes.string.isRequired,
  companyDetails: PropTypes.shape({
    name: PropTypes.string,
    phone: PropTypes.string,
  }),
  contactDetails: PropTypes.shape({
    name: PropTypes.string,
    phone: PropTypes.string,
  }),
  toggleText: PropTypes.string.isRequired,
  planEIN: PropTypes.string,
}

const defaultProps = {}

function AgreementDetailsDisclosure({
  sectionName,
  companyDetails,
  contactDetails,
  toggleText,
  planEIN,
}) {
  return (
    <Disclosure toggleText={toggleText} headingLevel={2}>
      <AgreementDetailsPanelContent
        sectionName={sectionName}
        companyDetails={companyDetails}
        contactDetails={contactDetails}
        planEIN={planEIN}
      />
    </Disclosure>
  )
}
AgreementDetailsDisclosure.propTypes = propTypes
AgreementDetailsDisclosure.defaultProps = defaultProps

export default AgreementDetailsDisclosure
